<template>
  <div class="pa-4 text-center grey lighten-2">
    <div class="text-center grey--text text--darken-2 text-subtitle-1">
      {{ title }}
    </div>
    <div class="text-center grey--text text--darken-4 text-h4"
    >
      {{ isNaN(value) || value === null ? '' : value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'greyBarWithTitleAndValue',
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
